import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FileUploadResource } from '../../resources/file-upload.resource';
import { MatchTenantAndAuthorizationParams } from '../../../tenancy/util/tenant-params';

@Component({
	selector: 'ws-img-upload',
	templateUrl: 'image-upload.component.html',
	styleUrls: ['image-upload.component.scss'],
})
export class ImageUploadComponent implements OnDestroy {
	@Input() showSelectedImage = true;
	@Input() imageId: string | undefined;
	@Input() backgroundImage: string | undefined;

	@Output() imageIdChange = new EventEmitter<string | undefined>();

	public uploading = false;
	public selectedFile: File | undefined;

	constructor(private fileUploadResource: FileUploadResource) {}

	onFileSelected(event: any) {
		const file: File = event.target.files[0];
		if (file) {
			this.selectedFile = file;
		}
	}

	public resetSelection() {
		this.selectedFile = undefined;
	}

	public deleteExistingImage() {
		this.imageId = undefined;
		this.imageIdChange.emit(this.imageId);
	}

	public async update(): Promise<string | undefined> {
		if (this.selectedFile) {
			// Upload new file
			this.uploading = true;
			try {
				const data = new FormData();
				data.set('file', this.selectedFile);
				const response = await this.fileUploadResource.upsert(new MatchTenantAndAuthorizationParams(), data);
				if (response.body) {
					this.imageId = response.body as string;
					this.imageIdChange.emit(this.imageId);
					this.resetSelection();
					return this.imageId;
				}
			} catch (error) {
				console.error('Error uploading file:', error);
				throw error;
			} finally {
				this.uploading = false;
			}
		}
		// Return existing imageId or undefined
		return this.imageId;
	}

	public get hasExistingImage(): boolean {
		return !!this.imageId && !this.selectedFile;
	}

	public get showUploadForm(): boolean {
		return !this.hasExistingImage && (!this.selectedFile || !this.showSelectedImage);
	}

	public get hasNewFileSelected(): boolean {
		return !!this.selectedFile;
	}

	ngOnDestroy() {
		this.imageIdChange.complete();
	}
}
